module.exports = __webpack_public_path__ + "static/5-c1d99f1f0deb7ea8b21983ac51da6ec5.png";